import { StoreService } from '../core/store.service';
import { BaseStore, GenericData, Stage, eItem, SessionItem, Address, StageDataOPT } from '../shared';
import { PathName } from '../shared/path.model';

export class BaseStage extends BaseStore {

  constructor(protected store: StoreService) { super(store); }

  protected setStage(c: Stage): void {
    this.store.PathItem.SetPathItem(PathName.STAGE, c.Ident, c);

    let item: SessionItem | null = super.getSession(eItem.STAGE);
    if (!item)
      item = new SessionItem(eItem.STAGE);

    item.id = c.Ident;
    item.desc = c.Info_PRO;
    item.jsData = JSON.stringify(c);
    this.store.AddDataSession(item);
  }

  protected filterStagesDate(list: GenericData<Stage>[], yearP: number, monthP: number): GenericData<Stage>[] {
    let result: GenericData<Stage>[] = [];
    let ms: Stage[] = [];
    for (let n: number = 0; n < list.length; n++) {
      const t: Stage[] = list[n].listFils.filter((e: Stage): boolean => e.year === yearP && e.month === monthP);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(this.store.getTrad('nostage')); }
    result = this.store.convertList<Stage>(ms, 2);
    return result;
  }

  protected filterStagesProd(list: GenericData<Stage>[], codeProduct: string): GenericData<Stage>[] {
    let result: GenericData<Stage>[] = [];
    let ms: Stage[] = [];
    for (let n: number = 0; n < list.length; n++) {
      const t: Stage[] = list[n].listFils.filter((e: Stage): boolean => e.ProduPRO === codeProduct);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(`${this.store.getTrad('nostage')} for the product ${codeProduct}`); }
    result = this.store.convertList<Stage>(ms, 2);
    return result;
  }
  protected filterStagesProd2(list: GenericData<StageDataOPT>[], codeProduct: string): GenericData<StageDataOPT>[] {
    let result: GenericData<StageDataOPT>[] = [];
    let ms: StageDataOPT[] = [];
    for (let n: number = 0; n < list.length; n++) {
      const t: StageDataOPT[] = list[n].listFils.filter((e: StageDataOPT): boolean => e.ProduPRO === codeProduct);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(`${this.store.getTrad('nostage')} for the product ${codeProduct}`); }
    result = this.store.convertList<StageDataOPT>(ms, 2);
    return result;
  }

  protected filterStagesAddress(list: GenericData<Stage>[], address: Address): GenericData<Stage>[] {
    let result: GenericData<Stage>[] = [];
    let ms: Stage[] = [];
    for (let n: number = 0; n < list.length; n++) {
      for (let x: number = 0; x < list[n].listFils.length; x++) {
        if (list[n].listFils[x].AddressesList) { // && list[n].listFils[x].AddressesList.indexOf(address) > -1) {
          const rs: Address[] = list[n].listFils[x].AddressesList.filter((a: Address): boolean => a.FormatADR === address.FormatADR);
          if (rs.length > 0) {
            ms = ms.concat(list[n].listFils[x]);
          }
        }
      }
    }
    if (ms.length === 0) { this.store.warning(`${this.store.getTrad('nostage')} for the address ${address.FormatADR}`); }
    result = this.store.convertList<Stage>(ms, 2);
    return result;
  }
}
